import * as React from 'react';

type Props = {
  label: string;
  required?: boolean;               // adds .field-required red border (per Heni V5)
  children: React.ReactNode;        // the value cell — input, text, toggle, etc.
};

/**
 * V3SpecRow — single row inside a specs table.
 *
 * Layout: uppercase label on the left, value cell on the right.
 * Used in: workspace left panel module/location/building specs
 * tables, modal step 3 module dimensions display.
 *
 * `required` applies the .field-required class which adds a red
 * border to highlight unfilled mandatory fields (per Heni V5's
 * updateSectionBadges pattern).
 */
const V3SpecRow: React.SFC<Props> = ({ label, required, children }) => (
  <div className={`v3-specs-row ${required ? 'field-required' : ''}`}>
    <span className="v3-spec-lbl">{label}</span>
    <div className="v3-spec-val-wrap">{children}</div>
  </div>
);

export default V3SpecRow;
